module.exports = __webpack_public_path__ + "static/woonhavenfull-72cfa39560494c3d335b4be5711d8ddc.jpg";